import { render, staticRenderFns } from "./DenglvHome.vue?vue&type=template&id=c25116b6&scoped=true"
import script from "./DenglvHome.vue?vue&type=script&lang=js"
export * from "./DenglvHome.vue?vue&type=script&lang=js"
import style0 from "./DenglvHome.vue?vue&type=style&index=0&id=c25116b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c25116b6",
  null
  
)

export default component.exports